import { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { label: '首页', href: '#hero' },
  { label: '主题索引', href: '#index' },
  { label: '热门排行', href: '#ranking' },
  { label: '焦点专题', href: '#carousel' },
  { label: '最新更新', href: '#updates' },
  { label: '关于我们', href: '#about' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const linkClass = (isMobile: boolean) =>
    `whitespace-nowrap transition-colors duration-200 cursor-pointer ${
      scrolled
        ? 'text-foreground-700 hover:text-primary-500'
        : 'text-white/90 hover:text-white'
    } ${isMobile ? 'block py-3 px-4 text-base font-medium text-foreground-800 hover:text-primary-500 hover:bg-primary-50 rounded-lg' : 'text-sm font-medium'}`;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1440px] mx-auto">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className={`font-heading text-xl whitespace-nowrap cursor-pointer transition-colors ${
              scrolled ? 'text-primary-500' : 'text-white'
            }`}
          >
            土豪漫画
          </a>

          <div className="hidden md:flex items-center gap-8">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={linkClass(false)}
              >
                {item.label}
              </a>
            ))}
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer rounded-lg transition-colors ${
              scrolled ? 'text-foreground-800 hover:bg-background-200' : 'text-white hover:bg-white/10'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className={linkClass(true)}
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}